export const ONBOARDER_NAME = 'web';
